export default {
  applies_to_articles: "S'applique aux articles suivants",
};
